import React from 'react';
import { EngineeringBridgeShell } from '../components/EngineeringBridge/EngineeringBridgeShell';

const EngineeringBridgePage: React.FC = () => {
  return <EngineeringBridgeShell />;
};

export default EngineeringBridgePage;